/**
 * GeoJSON-style territory polygon definitions for War of 1812.
 *
 * Each territory is defined by real-world approximate lat/lng coordinates
 * that tile together on a Leaflet map of eastern North America.
 * Coordinates form closed polygons (first point == last point).
 *
 * labelPos: [lat, lng] for the territory name label
 */

const territoryGeo = {
  // ── Great Lakes Theater ──────────────────────────────────────

  upper_canada: {
    coords: [
      [48.0, -80.0], [48.0, -76.0], [46.5, -74.5], [45.5, -75.5],
      [44.5, -76.5], [44.0, -77.5], [43.8, -79.0], [43.5, -79.5],
      [43.2, -80.0], [44.0, -81.5], [45.5, -82.0], [48.0, -84.0],
      [48.0, -80.0]
    ],
    labelPos: [46.0, -78.5],
  },

  montreal: {
    coords: [
      [48.0, -76.0], [48.0, -72.0], [47.0, -70.0], [46.0, -71.5],
      [45.5, -73.0], [45.0, -73.5], [45.0, -74.0], [45.5, -75.5],
      [46.5, -74.5], [48.0, -76.0]
    ],
    labelPos: [46.8, -73.5],
  },

  lake_ontario: {
    coords: [
      [44.5, -76.5], [45.0, -74.0], [44.5, -74.0], [43.8, -75.5],
      [43.5, -76.5], [43.3, -77.5], [44.0, -77.5], [44.5, -76.5]
    ],
    labelPos: [44.0, -76.0],
  },

  niagara: {
    coords: [
      [44.0, -77.5], [43.3, -77.5], [43.0, -78.0], [42.8, -79.0],
      [43.2, -79.5], [43.5, -79.5], [43.8, -79.0], [44.0, -77.5]
    ],
    labelPos: [43.3, -78.5],
  },

  lake_erie: {
    coords: [
      [43.2, -80.0], [43.5, -79.5], [43.2, -79.5], [42.8, -79.0],
      [42.5, -79.5], [42.2, -80.5], [41.8, -81.0], [41.5, -82.5],
      [41.8, -83.0], [42.3, -82.5], [42.8, -81.0], [43.2, -80.0]
    ],
    labelPos: [42.3, -80.8],
  },

  detroit: {
    coords: [
      [44.0, -81.5], [43.2, -80.0], [42.8, -81.0], [42.3, -82.5],
      [41.8, -83.0], [42.0, -84.0], [42.8, -84.5], [44.0, -84.5],
      [45.0, -84.0], [45.5, -82.0], [44.0, -81.5]
    ],
    labelPos: [43.0, -83.0],
  },

  fort_dearborn: {
    coords: [
      [45.0, -84.0], [44.0, -84.5], [42.8, -84.5], [42.0, -84.0],
      [41.8, -85.0], [41.5, -87.5], [42.5, -87.5], [44.0, -87.5],
      [45.5, -87.0], [45.5, -85.0], [45.0, -84.0]
    ],
    labelPos: [43.5, -86.0],
  },

  // ── Chesapeake Theater ───────────────────────────────────────

  new_york: {
    coords: [
      [44.5, -74.0], [45.0, -74.0], [45.0, -73.5], [44.5, -72.0],
      [43.0, -72.0], [41.5, -72.0], [40.5, -74.0], [41.0, -75.0],
      [42.0, -76.0], [43.0, -76.5], [43.5, -76.5], [43.8, -75.5],
      [44.5, -74.0]
    ],
    labelPos: [42.8, -74.0],
  },

  baltimore: {
    coords: [
      [41.0, -75.0], [40.5, -74.0], [39.8, -74.5], [39.5, -75.5],
      [39.5, -76.0], [39.8, -76.5], [40.5, -76.5], [41.0, -76.0],
      [41.0, -75.0]
    ],
    labelPos: [40.2, -75.5],
  },

  washington_dc: {
    coords: [
      [39.8, -76.5], [39.5, -76.0], [39.0, -76.5], [38.5, -77.0],
      [38.5, -77.8], [39.0, -78.0], [39.5, -77.5], [40.5, -76.5],
      [39.8, -76.5]
    ],
    labelPos: [39.2, -77.0],
  },

  bladensburg: {
    coords: [
      [39.5, -76.0], [39.5, -75.5], [39.0, -75.0], [38.5, -75.5],
      [38.0, -76.0], [38.5, -76.5], [39.0, -76.5], [39.5, -76.0]
    ],
    labelPos: [38.8, -75.8],
  },

  chesapeake_bay: {
    coords: [
      [38.5, -75.5], [39.0, -75.0], [39.5, -75.5], [39.8, -74.5],
      [40.5, -74.0], [40.0, -73.0], [39.0, -73.0], [37.5, -74.0],
      [37.0, -75.0], [37.5, -75.5], [38.0, -76.0], [38.5, -75.5]
    ],
    labelPos: [38.5, -74.2],
  },

  virginia: {
    coords: [
      [39.0, -78.0], [38.5, -77.8], [38.5, -77.0], [38.0, -76.0],
      [37.5, -75.5], [37.0, -75.0], [36.5, -76.0], [36.5, -78.0],
      [37.0, -80.0], [38.0, -80.0], [39.0, -78.0]
    ],
    labelPos: [37.5, -78.0],
  },

  // ── Southern Theater ─────────────────────────────────────────

  carolina: {
    coords: [
      [36.5, -78.0], [36.5, -76.0], [35.0, -75.5], [33.5, -77.5],
      [33.0, -79.5], [33.0, -81.0], [34.0, -81.0], [35.5, -81.0],
      [36.5, -78.0]
    ],
    labelPos: [35.0, -78.5],
  },

  creek_nation: {
    coords: [
      [35.5, -81.0], [34.0, -81.0], [33.0, -81.0], [33.0, -79.5],
      [32.0, -81.0], [31.0, -82.5], [31.0, -85.0], [32.5, -86.0],
      [34.0, -86.0], [35.0, -85.0], [35.5, -84.0], [35.5, -81.0]
    ],
    labelPos: [33.0, -83.5],
  },

  mississippi_territory: {
    coords: [
      [35.0, -85.0], [34.0, -86.0], [32.5, -86.0], [31.0, -85.0],
      [31.0, -88.0], [31.5, -90.0], [33.0, -91.0], [35.0, -91.0],
      [35.0, -88.0], [35.0, -85.0]
    ],
    labelPos: [33.0, -88.5],
  },

  mobile: {
    coords: [
      [31.0, -85.0], [31.0, -82.5], [30.0, -83.5], [29.5, -85.0],
      [29.5, -87.5], [30.0, -88.5], [31.0, -88.0], [31.0, -85.0]
    ],
    labelPos: [30.3, -85.5],
  },

  new_orleans: {
    coords: [
      [31.5, -90.0], [31.0, -88.0], [30.0, -88.5], [29.5, -87.5],
      [29.0, -89.0], [28.5, -90.5], [29.0, -91.5], [30.0, -92.0],
      [31.5, -91.5], [31.5, -90.0]
    ],
    labelPos: [30.0, -90.0],
  },

  gulf_of_mexico: {
    coords: [
      [29.5, -87.5], [29.5, -85.0], [29.0, -83.5], [28.0, -83.0],
      [27.0, -84.0], [26.5, -87.0], [27.0, -89.5], [28.5, -90.5],
      [29.0, -89.0], [29.5, -87.5]
    ],
    labelPos: [27.8, -86.5],
  },

  // ── Interior Connectors ──────────────────────────────────────

  ohio_valley: {
    coords: [
      [42.5, -79.5], [42.8, -79.0], [43.0, -78.0], [43.0, -76.5],
      [42.0, -76.0], [41.0, -76.0], [41.0, -75.0], [40.5, -76.5],
      [39.5, -77.5], [39.0, -78.0], [38.0, -80.0], [37.0, -80.0],
      [37.0, -81.5], [38.5, -82.0], [39.5, -82.5], [40.5, -82.0],
      [41.5, -81.0], [42.2, -80.5], [42.5, -79.5]
    ],
    labelPos: [40.0, -79.0],
  },

  indiana_territory: {
    coords: [
      [41.8, -85.0], [42.0, -84.0], [41.8, -83.0], [41.5, -82.5],
      [40.5, -82.0], [39.5, -82.5], [38.5, -82.0], [37.0, -81.5],
      [37.0, -83.0], [36.5, -84.0], [35.5, -84.0], [35.0, -85.0],
      [35.0, -88.0], [35.0, -91.0], [38.5, -91.0],
      [39.0, -88.0], [40.0, -87.5], [41.5, -87.5], [41.8, -85.0]
    ],
    labelPos: [38.0, -86.5],
  },

  // ── Maritime Theater ─────────────────────────────────────────

  halifax: {
    coords: [
      [48.0, -72.0], [49.0, -67.0], [47.5, -63.0], [46.0, -60.0],
      [44.5, -63.5], [43.5, -65.5], [44.0, -67.0], [44.5, -68.0],
      [44.5, -72.0], [46.0, -71.5], [47.0, -70.0], [48.0, -72.0]
    ],
    labelPos: [46.5, -65.0],
  },

  atlantic_sea_lanes: {
    coords: [
      [43.5, -65.5], [44.5, -63.5], [44.0, -60.0], [42.0, -58.0],
      [38.0, -60.0], [34.0, -64.0], [32.0, -68.0], [33.5, -72.0],
      [35.0, -75.5], [36.5, -76.0], [37.0, -75.0], [37.5, -74.0],
      [39.0, -73.0], [40.0, -73.0], [41.5, -72.0], [43.0, -72.0],
      [44.0, -67.0], [43.5, -65.5]
    ],
    labelPos: [37.0, -68.0],
  },
};

/** Theater label positions [lat, lng] */
export const theaterLabels = [
  { name: 'GREAT LAKES THEATER', pos: [47.0, -82.0] },
  { name: 'CHESAPEAKE THEATER', pos: [41.5, -74.5] },
  { name: 'SOUTHERN THEATER', pos: [32.0, -90.5] },
  { name: 'MARITIME THEATER', pos: [41.0, -62.0] },
];

export default territoryGeo;
